import { IconCheckmarkBadge } from '@leland-dev/leland-ui-library';
import React, { useState } from 'react';

import useMediaQuery, { Breakpoints } from '../../utils/hooks/useMediaQuery';
import { OrganizationImg, OrganizationType } from '../common/OrganizationImg';

import type { CoachEducationEducationFragment } from './__generated-gql-types__/CoachEducation.generated';

interface CoachEducationProps {
  educationExperiences: CoachEducationEducationFragment[];
}

const CoachEducation: React.FC<CoachEducationProps> = ({
  educationExperiences,
}) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const isTablet = useMediaQuery(Breakpoints.TAB);

  return (
    <>
      <h2 className="mb-8 text-left text-2xl font-medium text-leland-gray-dark">
        Education
      </h2>
      {educationExperiences.map((educationExperience, index) => (
        <div
          key={index}
          className={`flex items-start ${
            index !== educationExperiences.length - 1 ? 'my-12' : ''
          }`}
        >
          <OrganizationImg
            xl
            nonSizeClassName="mr-4 rounded"
            pictureLink={educationExperience.school.logoLink}
            name={educationExperience.school.name}
            type={OrganizationType.SCHOOL}
          />
          <div className="flex w-full flex-col text-left font-medium text-leland-gray-light">
            <h3 className="text-lg font-medium text-leland-gray-dark">
              {educationExperience.school.name}
            </h3>
            <div className="mt-1 flex flex-col items-start justify-center leading-snug">
              <div className="flex items-center justify-start">
                <p className="text-base">
                  {educationExperience.degree}
                  {educationExperience.major
                    ? `, ${educationExperience.major}`
                    : null}
                </p>
                {(educationExperience.startAt ?? educationExperience.endAt) ? (
                  <div className="flex items-center justify-start">
                    <div className="mx-2 size-0.5 rounded bg-leland-gray-light" />
                    <p className="text-base">{`${
                      educationExperience.startAt?.year ?? ''
                    }${
                      educationExperience.startAt && educationExperience.endAt
                        ? ' - '
                        : ''
                    }${educationExperience.endAt?.year ?? ''}`}</p>
                  </div>
                ) : null}
              </div>
              {educationExperience.admissionCommittee ? (
                <div className="mt-3 flex items-center space-x-1.5 text-leland-blue">
                  <IconCheckmarkBadge className="size-4.5" />
                  <p className="font-medium">Admissions Committee Experience</p>
                </div>
              ) : null}
            </div>
            {(isTablet || isDescriptionExpanded) &&
            educationExperience.description ? (
              <p className="mt-3 whitespace-pre-line text-base font-normal">
                {educationExperience.description}
              </p>
            ) : null}
            {!isTablet && educationExperience.description ? (
              <button
                className="link link--primary mt-1.5 text-left text-base font-medium"
                onClick={() =>
                  setIsDescriptionExpanded((prevState) => !prevState)
                }
                id="coach_education:toggle_description"
              >
                {isDescriptionExpanded ? 'See less' : 'See more'}
              </button>
            ) : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default CoachEducation;
